import { useEffect } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';
import posthog from 'posthog-js';
// posthog-js' default export is a module singleton, initialised once by src/app/config/PostHog.ts
// (imported from src/app/index.tsx). The entities layer must not import from the app layer
// (dependency-cruiser rule), so `enabled` is derived locally from the same build-time constant.
const posthogEnabled = Boolean(__POSTHOG_KEY__);
/**
 * Identifies the PostHog person with the Cognito `sub` (never email or name — 17 §4).
 *
 * The app's AuthUser.id is `cognito:username`, not the `sub`, so the `sub` claim is read from the
 * id token here. On sign-out (no user) the person is reset.
 */
export function usePostHogIdentify(user) {
    useEffect(() => {
        if (!posthogEnabled)
            return;
        if (!user) {
            posthog.reset();
            return;
        }
        let cancelled = false;
        fetchAuthSession()
            .then(session => {
            var _a, _b, _c;
            const sub = (_c = (_b = (_a = session.tokens) === null || _a === void 0 ? void 0 : _a.idToken) === null || _b === void 0 ? void 0 : _b.payload) === null || _c === void 0 ? void 0 : _c.sub;
            if (!cancelled && sub) {
                posthog.identify(sub);
            }
        })
            .catch(() => {
            /* not signed in / session unavailable — stay anonymous */
        });
        return () => {
            cancelled = true;
        };
    }, [user]);
}
